<template>
  <div
    class="inline-flex items-center bg-neutral-200 rounded-lg p-1"
    :class="{ 'flex-wrap': wrap }"
  >
    <button
      v-for="tab in tabs"
      :key="tabKey(tab)"
      type="button"
      class="px-3 py-1.5 text-sm font-medium rounded-md transition-colors inline-flex items-center gap-1.5 whitespace-nowrap"
      :class="value === tabKey(tab) ? 'bg-white shadow-sm text-neutral-900' : 'text-neutral-600 hover:text-neutral-900'"
      @click="$emit('input', tabKey(tab))"
    >
      {{ tab.label }}
      <slot name="badge" :tab="tab" :active="value === tabKey(tab)"></slot>
    </button>
  </div>
</template>

<script>
// The app's one segmented-control/tab component (board tabs, settings tabs,
// import tabs, docs tabs). tabs: [{ name, label }], v-model on the active name.
export default {
  name: "TabGroup",
  props: {
    tabs: { type: Array, required: true },
    value: { type: [String, Number], default: null },
    wrap: { type: Boolean, default: false },
    // The property on each tab that identifies it. Defaults to "name"; callers
    // whose data uses "id" (or anything else) can point at it instead.
    keyName: { type: String, default: "name" },
  },
  methods: {
    tabKey(tab) {
      return tab[this.keyName];
    },
  },
};
</script>
